<template id="custom-select">
  <ValidationProvider :name="name" :rules="validationRules" v-slot="v" slim>
    <div class="field" v-bind:class="[{ 'error': ( v.validated && v.invalid ) || ( errors && errors[name]) }, size, { 'wide' : size.length > 0 }, { 'disabled' : disabled }]">
      <label v-if="labelVisible" style="display: flex;">{{ label }} <div :data-tooltip="tooltip" data-position="top left"><i style="font-size: 10px; margin-left: 3px;" v-if="labelIcon != ''" :class="labelIcon"></i></div></label>
      <input v-model="input" :type="type" :value="value" @keyup="keyup" @keypress="keypress" @change="change" v-mask="mask" :maxlength="maxlength" :placeholder="placeholder" :readonly="readonly" :disabled="disabled"/>
      <span v-if="v.validated && v.invalid" class="ui red basic label error">{{ v.errors[0] }}</span>
      <div class="ui basic mini red pointing prompt label" v-if="errors && errors[name]">{{ errors[name].join(" | ") }}</div>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'Input',
  components: {
    ValidationProvider,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
      default: 'Sem Label',
    },
    labelIcon: {
      type: String,
      default: '',
    },
    labelVisible: {
      type: Boolean,
      default: true,
    },
    validationRules: {
      type: String,
      default: '',
    },
    mask: {
      type: [Array, String],
    },
    size: {
      type: String,
      default: 'four',
    },
    maxlength: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: [Object, Array],
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      input: this.value,
    };
  },
  methods: {
    change(e) {
      this.$emit('input', e.target.value);
    },
    keyup(e) {
      this.$emit('keyup', e.target.value);
    },
    keypress(e) {
      this.$emit('keypress', e.target.value);
    },
    generateSpace() {
      return String.fromCharCode(160);
    },
  },
  watch: {
    value: {
      immediate: false,
      handler(value) {
        this.input = value;
      },
    },
  },
};
</script>

<style lang="scss">
span.ui.basic.red.label.error {
  border: none;
  background-color: transparent !important;
  padding: 0;
  font-size: 11px;
}
</style>
